import { render } from "./AppNotifications.vue?vue&type=template&id=0e930142&scoped=true"
import script from "./AppNotifications.vue?vue&type=script&lang=js"
export * from "./AppNotifications.vue?vue&type=script&lang=js"

import "./AppNotifications.vue?vue&type=style&index=0&id=0e930142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e930142"]])

export default __exports__